module.exports = __webpack_public_path__ + "img/img2.4d875188.jpg";